import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Quote from '@/components/common/ui/Quote';
import styles from 'styles/jss/original/components/ideas/detailQuote';
import { IIdea } from '@/@types/generated/contentful';

const useStyles = makeStyles(styles);

type ComponentProps = {
  idea: IIdea;
};

const DetailQuote: React.FC<ComponentProps> = ({ idea }) => {
  const classes = useStyles();
  const { quote } = idea.fields;
  if (!quote) return null;

  return (
    <div className={classes.container}>
      {/* @ts-expect-error */}
      <GridContainer justify='center'>
        {/* @ts-expect-error */}
        <GridItem xs={12} sm={10} md={8}>
          <div className={classes.textQuote}>
            <Quote text={quote} />
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default DetailQuote;
